import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const MenuWaffleIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M4.6 11.02V4.56H11.06V11.02H4.6ZM12.94 11.02V4.56H19.4V11.02H12.94ZM6.1 9.52H9.56V6.06H6.1V9.52ZM14.44 9.52H17.9V6.06H14.44V9.52ZM4.6 19.36V12.9H11.06V19.36H4.6ZM12.94 19.36V12.9H19.4V19.36H12.94ZM6.1 17.86H9.56V14.4H6.1V17.86ZM14.44 17.86H17.9V14.4H14.44V17.86Z" />
    </SvgIcon>
  );
});
